'use client';

import { useParams, useSelectedLayoutSegments } from 'next/navigation';
import clsx from 'clsx';
import { Styles } from './sportsbook-main-container.style';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { SetShowPromotionStreamer } from '@/features/promotion/promotion';
export const SportsbookMainContainer = ({
	children
}: {
	children: React.ReactNode;
}) => {
	const params = useParams();
	const isSingleMatchPage = params.matchId !== undefined;
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const isNoneSidePage = selectedLayoutSegments.includes('(noneside)') || selectedLayoutSegments.includes('intro') || selectedLayoutSegments.includes('golden-duel');
	const hasHeader = !isNoneSidePage && !isSingleMatchPage;
	const isPromotionPage = selectedLayoutSegments.includes('promotion') && !selectedLayoutSegments.includes('jackpot') && !selectedLayoutSegments.includes('intro') && !selectedLayoutSegments.includes('widget') && !selectedLayoutSegments.includes('golden-duel') ;
	const ShowPromotionStreamerSrc = SetShowPromotionStreamer();
	const isShowPromotionChatroom =SiteConfigsData?.EnableChatroom && user?.ActStatus==2 && user.RewardInfo.EnableRewardSystem && ShowPromotionStreamerSrc.length > 0;
	
	return (
		<div 
			className={
				clsx('main-wrap container', {
					'main-wrap--no-header': !hasHeader,
					'main-wrap--no-aside': isNoneSidePage,
					'main-wrap--promotion': isPromotionPage,
				},
				Styles.main
				)
			}
			data-promo-chatroom={isPromotionPage && isShowPromotionChatroom}
		>
			{children}
		</div>
	);
};